import { createTheme } from '@mui/material/styles';

const muiTheme = createTheme({
    palette: {
        primary: {
            main: '#5AAD83',
            light: '#A7D9C0',
            dark: '#3A8F66',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#2582C5',
        },
        error: {
            main: '#D32F2F',
        },
        success: {
            main: '#388E3C',
        },
        background: {
            default: '#FAFAFA',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#29303A',
            secondary: '#475569',
        },
    },
    typography: {
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        fontSize: 14,
        h1: {
            fontSize: '2rem',
            fontWeight: 700,
        },
        h2: {
            fontSize: '1.5rem',
            fontWeight: 600,
        },
        body1: {
            fontSize: '1rem',
            lineHeight: 1.5,
        },
        button: {
            textTransform: 'none',
            fontSize: '0.875rem',
            fontWeight: 600,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    padding: '8px 20px',
                    fontSize: '0.875rem',
                    borderRadius: '8px',
                    transition: 'all 0.3s ease-in-out',
                },
                containedPrimary: {
                    backgroundColor: '#5AAD83',
                    '&:hover': {
                        backgroundColor: '#3A8F66',
                    },
                },
                containedSecondary: {
                    backgroundColor: '#2582C5',
                    '&:hover': {
                        backgroundColor: '#1C6A9F',
                    },
                },
                containedError: {
                    backgroundColor: '#D32F2F',
                    '&:hover': {
                        backgroundColor: '#B71C1C',
                    },
                },
                outlinedPrimary: {
                    borderColor: '#5AAD83',
                    color: '#5AAD83',
                    '&:hover': {
                        backgroundColor: '#5AAD83',
                        color: '#ffffff',
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#5AAD83',
                        },
                        '&:hover fieldset': {
                            borderColor: '#3A8F66',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#5AAD83',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#5AAD83',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: '#5AAD83',
                    },
                    '& .MuiInputBase-input::placeholder': {
                        color: '#5AAD83',
                        opacity: 1,
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#5AAD83',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3A8F66',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#5AAD83',
                    },
                },
                icon: {
                    color: '#5AAD83',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    padding: '24px',
                    borderRadius: '10px',
                    boxShadow:
                        'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                        boxShadow:
                            'rgba(0, 0, 0, 0.15) 0px 8px 12px -2px, rgba(0, 0, 0, 0.1) 0px 4px 6px -1px',
                    },
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    maxWidth: '1200px',
                    marginTop: '24px',
                    padding: '16px',
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    overflow: 'hidden',
                    border: '1px solid rgba(224, 224, 224, 1)',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    backgroundColor: '#5AAD83',
                    color: '#ffffff',
                    fontWeight: 'bold',
                    padding: '12px 16px',
                    fontSize: '1rem',
                },
                body: {
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    fontSize: '0.95rem',
                    padding: '10px 16px',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: '#F5F5F5',
                    },
                    '&:last-child td, &:last-child th': {
                        border: 0,
                    },
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    padding: '10px 16px',
                    transition: 'all 0.3s ease-in-out',
                    color: '#29303A',
                    '& .MuiListItemIcon-root': {
                        color: '#29303A',
                        transition: 'color 0.3s ease-in-out',
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(90, 173, 131, 0.08)',
                        color: '#3A8F66',
                        '& .MuiListItemIcon-root': {
                            color: '#3A8F66',
                        },
                    },
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(90, 173, 131, 0.12)',
                        color: '#3A8F66',
                        '& .MuiListItemIcon-root': {
                            color: '#3A8F66',
                        },
                        '&:hover': {
                            backgroundColor: 'rgba(90, 173, 131, 0.16)',
                        },
                    },
                },
            },
        },
    },
});

export default muiTheme;
